export default "__VITE_ASSET__C$pkdZY6__"